import { render, staticRenderFns } from "./PromotionPage.vue?vue&type=template&id=d2d05f4c"
import script from "./PromotionPage.vue?vue&type=script&lang=js"
export * from "./PromotionPage.vue?vue&type=script&lang=js"
import style0 from "./PromotionPage.vue?vue&type=style&index=0&id=d2d05f4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports